<template>
  <!-- eslint-disable -->
  <div>
    <div class="column-left">
      <SideNav />
    </div>
    <div class="medical-order-page">
      <TopNav />

      <!-- Estado -1: Selección de prestador (solo para ClinicGo) -->
      <div v-if="(estado == -1 && es_principal) && !loading_transferencia && !orden_enviada" class="step-container">
        <div class="step-header">
          <div class="step-number" :style="{
            backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
          }">0</div>
          <h2 class="step-title">Seleccione el prestador</h2>
        </div>

        <div class="content-card">
          <div v-if="!loading_prestador" class="provider-selector">
            <select @change="onSelectPrestadorChange" v-model="selectedPrestador" class="medical-select">
              <option v-for="prestador_ in prestadores" :key="prestador_.id" :value="prestador_.id">
                {{ prestador_.nombre }}
              </option>
            </select>
          </div>
          <div v-else class="loading-state">
            <div class="medical-spinner"></div>
            <span>Reconfigurando...</span>
          </div>

          <div class="navigation-buttons">
            <button @click="estado = 0" :style="{ 'background-color': prestador.atributos.assets.colors.primary }"
              class="primary-btn">
              Continuar
            </button>
          </div>
        </div>
      </div>

      <!-- Estado 0: Selección de comuna -->
      <div v-if="(estado == 0 || (estado == -1 && prestador.id != 1)) && !loading_transferencia && !orden_enviada"
        class="step-container">
        <div class="step-header">
          <div class="step-number" :style="{
            backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
          }">1</div>
          <h2 class="step-title">Datos del Paciente</h2>
          <p class="step-subtitle">Comencemos con la información básica del paciente</p>
        </div>

        <div class="content-card">
          <div class="patient-preview-section">
            <div class="section-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div class="section-content">
              <h3>Información del Paciente</h3>
              <p class="section-description">Los datos del paciente se completarán en los siguientes pasos</p>
            </div>
          </div>

          <div class="location-section">
            <div class="section-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </div>
            <div class="section-content">
              <h3>Ubicación del Servicio</h3>
              <div class="search-container">
                <input placeholder="Escribe tu comuna..." v-model="comuna_buscado"
                  @input="comuna_buscado = $event.target.value" type="text" class="medical-input">

                <div v-if="comuna_buscado != ''" class="search-dropdown">
                  <div v-if="resultado_fuse_comuna.length > 0">
                    <div v-for="c in resultado_fuse_comuna.slice(0, 6)" :key="c.item.id" @click="clickearComuna(c.item)"
                      class="dropdown-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                      {{ c.item.Nombre }}
                    </div>
                  </div>
                  <div v-else class="dropdown-item no-results">
                    No se encontraron comunas
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="navigation-buttons">
          <button v-if="estado > -1" @click="estado--" class="secondary-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5"></path>
              <path d="M12 19l-7-7 7-7"></path>
            </svg>
            Anterior
          </button>
          <button @click="estado++" :disabled="comuna === 0" 
            :style="{ 
              'background-color': prestador.atributos.assets.colors.primary,
              'opacity': comuna === 0 ? '0.5' : '1'
            }" 
            class="primary-btn">
            Siguiente
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Estado 1: Configuración de pacientes y exámenes -->
      <div v-if="estado == 1 && !loading_transferencia && !orden_enviada" class="step-container">
        <div class="step-header">
          <div class="step-number" :style="{
            backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
          }">2</div>
          <h2 class="step-title">Configuración de Servicios</h2>
          <p class="step-subtitle">Selecciona los exámenes y servicios médicos</p>
          <div v-if="isPrestador16" class="restriction-notice">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            <span>Limitado a un paciente y un examen por orden</span>
          </div>
        </div>

        <div class="two-column-layout">
          <div class="main-column">
            <div class="patients-section">
              <div v-if="examenes_agregados.length > 0" class="patients-container">
                <div v-for="(p, i) in examenes_agregados" :key="i" class="patient-card">
                  <div class="patient-header">
                    <div class="patient-info">
                      <div class="patient-avatar">{{ i + 1 }}</div>
                      <span class="patient-title">Paciente {{ i + 1 }}</span>
                    </div>
                    <!-- Permitir eliminar paciente siempre que no sea el único -->
                    <button v-if="!isPrestador16 || examenes_agregados.length > 1" @click="removerPaciente(i)"
                      class="remove-btn">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c0-1 1-2 2-2v2"></path>
                      </svg>
                    </button>
                  </div>

                  <div class="insurance-section">
                    <label class="field-label">Previsión:</label>
                    <select class="medical-select compact" v-model="p.aseguradora_id">
                      <option :value="0">Seleccionar</option>
                      <option v-for="a in aseguradoras" :value="a.id">{{ a.nombre }}</option>
                    </select>
                  </div>

                  <div class="services-table">
                    <div class="table-header">
                      <div class="col-service">Servicio</div>
                      <div class="col-price">Valor</div>
                      <div class="col-action"></div>
                    </div>

                    <div v-for="(grupo, j) in agruparExamenes(p.examenes)" :key="grupo.id" class="table-row">
                      <div class="col-service">
                        <div class="service-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                          </svg>
                        </div>
                        <span class="service-name">{{ getExamen(grupo.id).nombre }}</span>
                      </div>
                      <div class="col-price">
                        <div class="price-display" v-if="comuna != -1">
                          $ {{formatNum( (getPrecioExamen(grupo.id, comuna, p.categoria_cliente_id).precio -
                            getReembolsoExamen(grupo.id, p.aseguradora_id, p.categoria_cliente_id) - (valores_codigo.find((x)
                              => x.examen_id == grupo.id) || { valor: 0 }).valor) * grupo.cantidad )}}
                        </div>
                        <div class="select-comuna-btn" @click="$refs.modalcomuna.show()" v-else>
                          Seleccionar Comuna
                        </div>
                      </div>
                      <div class="col-action" style="display: flex; align-items: center; justify-content: flex-end; gap: 8px;">
                        <button @click="removerInstanciaExamen(i, grupo.id)" style="width: 24px; height: 24px; border-radius: 4px; border: 1px solid #e2e8f0; background: white; color: #64748b; font-weight: bold; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0;">-</button>
                        <span style="font-weight: 600; font-size: 14px; min-width: 20px; text-align: center;">{{ grupo.cantidad }}</span>
                        <button @click="agregarInstanciaExamen(i, grupo.id)" style="width: 24px; height: 24px; border-radius: 4px; border: 1px solid #e2e8f0; background: white; color: #64748b; font-weight: bold; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0;">+</button>
                        <button @click="removerExamenSeleccionado(i, grupo.id)" class="remove-service-btn" style="margin-left: 8px;">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div class="table-row delivery-row">
                      <div class="col-service">
                        <div class="service-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>
                            <path d="M15 18H9"></path>
                            <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14">
                            </path>
                            <circle cx="17" cy="18" r="2"></circle>
                            <circle cx="7" cy="18" r="2"></circle>
                          </svg>
                        </div>
                        <span class="service-name">Servicio domiciliario</span>
                      </div>
                      <div class="col-price">
                        <div class="price-display">
                          $ {{ formatNum(calcularCostoServicioPaciente(examenes_agregados.length, p.aseguradora_id,
                            p.categoria_cliente_id, i, comuna)) }}
                        </div>
                      </div>
                      <div class="col-action"></div>
                    </div>

                    <!-- Mostrar campo de búsqueda si no hay exámenes o si es prestador 16 (para permitir reemplazo) -->
                    <div v-if="!isPrestador16 || p.examenes.length < 1" class="add-service-row">
                      <div class="add-service-input">
                        <input :style="{ 'z-index': agregando_examen_paciente == i }"
                          @blur="_blur(); $event.target.value = ''" @focus="agregando_examen_paciente = i"
                          @input="buscando_examen = $event.target.value; agregando_examen_paciente = i;"
                          class="medical-input" type="text" placeholder="Agrega otro examen...">

                        <div v-if="agregando_examen_paciente == i && resultado_fuse_examen.length > 0"
                          :style="{ 'z-index': agregando_examen_paciente != -1 ? '9999' : '1' }"
                          class="service-dropdown">
                          <div @click="click_servicio(e.item, i)" class="service-option"
                            v-for="e in resultado_fuse_examen.slice(0, 3)" :key="e.item.id">
                            <div class="service-option-name">{{ e.item.nombre }}</div>
                            <div class="service-option-price">
                              {{
                                getPrecioExamen(e.item.id, comuna, p.categoria_cliente_id).multiples_precios && comuna < 0
                                  ? 'INDICAR COMUNA' : '$ ' + formatNum((getPrecioExamen(e.item.id, comuna,
                                    p.categoria_cliente_id).precio - getReembolsoExamen(e.item.id, p.aseguradora_id,
                                      p.categoria_cliente_id) - (valores_codigo.find((x) => x.examen_id == e.item.id) ||
                                        { valor: 0 }).valor
                                  ) > 0 ?
                                    (
                                      getPrecioExamen(e.item.id, comuna, p.categoria_cliente_id).precio
                                      - getReembolsoExamen(e.item.id, p.aseguradora_id, p.categoria_cliente_id)
                                      - (valores_codigo.find((x) => x.examen_id == e.item.id) || { valor: 0 }).valor
                                    )
                                    :
                                    0
                                  )
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Botón para agregar paciente (solo si no es prestador 16) -->
              <div v-if="!isPrestador16" class="add-patient-section">
                <button @click="agregarPaciente()" class="add-patient-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="8.5" cy="7" r="4"></circle>
                    <path d="M20 8v6"></path>
                    <path d="M23 11h-6"></path>
                  </svg>
                  Agregar otro paciente
                </button>
              </div>
            </div>
          </div>

          <div class="summary-column">
            <div class="summary-card">
              <h3 class="summary-title">Resumen de Servicios</h3>

              <div class="summary-items">
                <div v-for="p in examenes_agregados">
                  <div v-for="grupo in agruparExamenes(p.examenes)">
                    <div class="summary-item">
                      <div class="summary-item-name">{{ getExamen(grupo.id).nombre }} <span v-if="grupo.cantidad > 1" style="font-weight: bold; margin-left: 5px;">x{{ grupo.cantidad }}</span></div>
                      <div v-if="comuna != -1" class="summary-item-price">
                        {{
                          getPrecioExamen(grupo.id, comuna, p.categoria_cliente_id).multiples_precios && comuna < 0 ? '-' : '$ '
                            + formatNum(( (getPrecioExamen(grupo.id, comuna, p.categoria_cliente_id).precio - getReembolsoExamen(grupo.id,
                              p.aseguradora_id, p.categoria_cliente_id) - (valores_codigo.find((x) =>
                                x.examen_id == grupo.id) || { valor: 0 }).valor
                            ) > 0 ?
                              (
                                getPrecioExamen(grupo.id, comuna, p.categoria_cliente_id).precio
                                - getReembolsoExamen(grupo.id, p.aseguradora_id, p.categoria_cliente_id)
                                - (valores_codigo.find((x) => x.examen_id == grupo.id) || { valor: 0 }).valor
                              )
                              :
                              0
                            ) * grupo.cantidad)
                        }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="summary-divider"></div>
              </div>

              <div class="navigation-buttons">
                <button @click="estado--" class="secondary-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M19 12H5"></path>
                    <path d="M12 19l-7-7 7-7"></path>
                  </svg>
                  Anterior
                </button>
                <button @click="checkout()" :style="{ 'background-color': prestador.atributos.assets.colors.primary }"
                  class="primary-btn">
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estado 2: Selección de fecha y hora - CALENDARIO CORREGIDO -->
      <div v-if="estado == 2 && !loading_transferencia && !orden_enviada" class="step-container">
        <div class="step-header">
          <div class="step-number" :style="{
            backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
          }">3</div>
          <h2 class="step-title">Selecciona día y hora</h2>
          <p class="step-subtitle">Elige el momento más conveniente para tu cita</p>
        </div>

        <div class="calendar-layout">
          <!-- Sección del calendario -->
          <div class="calendar-section">
            <div class="calendar-card">
              <div class="calendar-header">
                <div class="calendar-title-section">
                  <div class="section-number">1</div>
                  <h3 class="section-title">Seleccione una fecha</h3>
                </div>

                <div class="calendar-navigation">
                  <h4 class="current-month">{{ meses[viendoMes] }} {{ viendoAño }}</h4>
                  <div class="nav-buttons">
                    <button @click="restarMes()" class="nav-btn">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M15 18l-6-6 6-6"></path>
                      </svg>
                    </button>
                    <button @click="sumarMes()" class="nav-btn">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M9 18l6-6-6-6"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div class="calendar-container">
                <div class="calendar-weekdays">
                  <div v-for="d in dias_av" :key="d" class="weekday-cell">{{ d }}</div>
                </div>

                <div class="calendar-weeks">
                  <!-- Generar semanas del calendario -->
                  <div v-for="week in calendarWeeks" :key="week.weekIndex" class="calendar-week">
                    <div v-for="day in week.days" :key="day.key" class="calendar-day" :class="{
                      'current-day': day.isToday,
                      'selected-day': day.isSelected,
                      'available-day': day.isAvailable,
                      'unavailable-day': day.isUnavailable,
                      'empty-day': day.isEmpty,
                      'other-month': day.isOtherMonth
                    }" :style="{
                      'background-color': day.isSelected ? prestador.atributos.assets.colors.primary : ''
                    }" @click="day.isEmpty || day.isOtherMonth ? null : seleccionarDia(day.day, day.month, day.year)">
                      <span v-if="!day.isEmpty">{{ day.day }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sección de horarios -->
          <div class="time-section">
            <div class="time-card">
              <div class="time-header">
                <div class="section-number">2</div>
                <h3 class="section-title">Seleccione un horario</h3>
              </div>

              <div v-if="!cargando_disponibles" class="time-content">
                <div v-if="buscadoDia != 0" class="selected-date-info">
                  <div class="date-badge">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    {{ buscadoDia }} de {{ meses[buscadoMes] }} de {{ buscadoAño }}
                  </div>
                </div>

                <div class="time-slots-container">
                  <!-- Horarios de mañana -->
                  <div v-if="horasDisponiblesC.some(h => h.desde < 720)" class="time-period">
                    <h4 class="period-title">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="5"></circle>
                        <line x1="12" y1="1" x2="12" y2="3"></line>
                        <line x1="12" y1="21" x2="12" y2="23"></line>
                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                        <line x1="1" y1="12" x2="3" y2="12"></line>
                        <line x1="21" y1="12" x2="23" y2="12"></line>
                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                      </svg>
                      Mañana
                    </h4>
                    <div class="time-grid">
                      <button v-for="h in horasDisponiblesC.filter(slot => slot.desde < 720)"
                        :key="'morning-' + h.desde" @mouseenter="h.hovering = true;" @mouseleave="h.hovering = false;"
                        @click="selectTimeSlot(h)" class="time-slot" :class="{
                          'selected': h.desde == tiSelected && h.hasta == tfSelected,
                          'hovering': h.hovering
                        }" :style="{
                          'background-color': (h.desde == tiSelected && h.hasta == tfSelected) || h.hovering ? prestador.atributos.assets.colors.primary : '',
                          color: (h.desde == tiSelected && h.hasta == tfSelected) || h.hovering ? 'white' : h.color,
                          'border-color': h.desde == tiSelected && h.hasta == tfSelected ? prestador.atributos.assets.colors.primary : h.color
                        }">
                        <div class="time-range">{{ timeConvert(h.desde) }} - {{ timeConvert(h.hasta) }}</div>
                        <div v-if="h.recargo_suma > 0 || h.recargo_porcentaje > 0" class="time-surcharge">
                          +{{ h.recargo_suma > 0 ? '$' + formatNum(h.recargo_suma) : h.recargo_porcentaje + '%' }}
                        </div>
                      </button>
                    </div>
                  </div>

                  <!-- Horarios de tarde -->
                  <div v-if="horasDisponiblesC.some(h => h.desde >= 720)" class="time-period">
                    <h4 class="period-title">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                      </svg>
                      Tarde
                    </h4>
                    <div class="time-grid">
                      <button v-for="h in horasDisponiblesC.filter(slot => slot.desde >= 720)"
                        :key="'afternoon-' + h.desde" @mouseenter="h.hovering = true;" @mouseleave="h.hovering = false;"
                        @click="selectTimeSlot(h)" class="time-slot" :class="{
                          'selected': h.desde == tiSelected && h.hasta == tfSelected,
                          'hovering': h.hovering
                        }" :style="{
                          'background-color': (h.desde == tiSelected && h.hasta == tfSelected) || h.hovering ? prestador.atributos.assets.colors.primary : '',
                          color: (h.desde == tiSelected && h.hasta == tfSelected) || h.hovering ? 'white' : h.color,
                          'border-color': h.desde == tiSelected && h.hasta == tfSelected ? prestador.atributos.assets.colors.primary : h.color
                        }">
                        <div class="time-range">{{ timeConvert(h.desde) }} - {{ timeConvert(h.hasta) }}</div>
                        <div v-if="h.recargo_suma > 0 || h.recargo_porcentaje > 0" class="time-surcharge">
                          +{{ h.recargo_suma > 0 ? '$' + formatNum(h.recargo_suma) : h.recargo_porcentaje + '%' }}
                        </div>
                      </button>
                    </div>
                  </div>

                  <div v-if="horasDisponiblesC.length == 0 && buscadoDia != 0" class="no-times-available">
                    <div class="no-times-icon">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                      </svg>
                    </div>
                    <h4>No hay horarios disponibles</h4>
                    <p>Por favor, selecciona otro día para ver los horarios disponibles.</p>
                  </div>
                </div>
              </div>

              <div v-if="cargando_disponibles" class="loading-times">
                <div class="medical-spinner"></div>
                <span>Cargando horarios disponibles...</span>
              </div>
            </div>
          </div>
        </div>

        <div class="navigation-buttons">
          <button @click="estado--" class="secondary-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5"></path>
              <path d="M12 19l-7-7 7-7"></path>
            </svg>
            Anterior
          </button>
          <button @click="checkout_fecha_y_hora()" :disabled="tiSelected === -1 || tfSelected === -1" :style="{
            'background-color': prestador.atributos.assets.colors.primary,
            'opacity': tiSelected !== -1 && tfSelected !== -1 ? '1' : '0.5'
          }" class="primary-btn">
            Siguiente
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Estado 3: Datos del paciente -->
      <div v-if="estado == 3 && !loading_transferencia && !orden_enviada" class="step-container">
        <div class="step-header">
          <div class="step-number" :style="{
            backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
          }">4</div>
          <h2 class="step-title">Información Completa del Paciente</h2>
          <p class="step-subtitle">Complete todos los datos necesarios para el servicio médico</p>
        </div>

        <div class="patient-data-container">
          <div v-for="(p, i) in examenes_agregados" :key="i" class="patient-form-card">
            <div @click="examen_buscado = ''; agregando_examen = false;" v-b-toggle="'accordion-' + (i + 1)"
              class="patient-form-header">
              <div class="patient-form-title">
                <div class="patient-avatar">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <span>{{ p.nombre != '' ? p.nombre + ' ' + p.apellido1 : 'Paciente ' + (i + 1) }}</span>
              </div>

              <div class="expand-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  :style="{ 'transform': p.visible ? 'rotate(180deg)' : 'none' }">
                  <path d="M6 9l6 6 6-6"></path>
                </svg>
              </div>
            </div>

            <b-collapse v-model="p.visible" v-bind:id="'accordion-' + (i + 1)" accordion="my-accordion"
              class="patient-form-content">
              <div class="form-grid">
                <!-- RUT/Identificador -->
                <div class="form-field full-width">
                  <label class="field-label">
                    Rut o identificador
                    <div class="validation-status">
                      <div
                        v-if="p.cargando_rut && prestador.atributos.config.requiere_verificar_ruts == 1 && verificar_rut(p.rut) && !focused_rut"
                        class="loading-indicator">
                        <div class="medical-spinner small"></div>
                      </div>
                      <div
                        v-if="prestador.atributos.config.requiere_verificar_ruts == 1 && p.habilitado == 1 && !p.cargando_rut && verificar_rut(p.rut)"
                        class="validation-success">
                        Admisible ✓
                      </div>
                      <div
                        v-if="prestador.atributos.config.requiere_verificar_ruts == 1 && p.habilitado != 1 && !p.cargando_rut && verificar_rut(p.rut)"
                        class="validation-error">
                        No admisible ✗
                      </div>
                      <div v-if="!verificar_rut(p.rut) && p.rut != '' && !focused_rut && p.tipo_identificador == 'rut'"
                        class="validation-error">
                        Formato Incorrecto
                      </div>
                    </div>
                  </label>

                  <div class="input-group d-flex" style="position: relative;">
                    <div class="input-prefix ident_prefico" @click.stop="p.seleccionando_rut = !p.seleccionando_rut" style="cursor: pointer; flex-shrink: 0;">
                      <span class="ident_prefico">{{tipo_identificador.find(x => { return p.tipo_identificador == x.valor }).nombre}}</span>
                      <svg class="ident_prefico" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path class="ident_prefico" d="M6 9l6 6 6-6"></path>
                      </svg>
                    </div>

                    <input
                      :class="{ 'error': !verificar_rut(p.rut) && p.rut != '' && !focused_rut && p.tipo_identificador == 'rut' }"
                      v-model="p.rut" @focus="focused_rut = true;" @blur="focused_rut = false; autocompleteClient(p)"
                      @input="p.rut = $event.target.value; p.cargando_rut = true;" placeholder="12345678-9"
                      class="medical-input" type="text" style="border-radius: 0 8px 8px 0; flex: 1; width: auto;">

                    <div v-if="p.seleccionando_rut" class="custom-dropdown ident_prefico">
                      <div v-for="t in tipo_identificador" :key="t.valor"
                        @click.stop="p.tipo_identificador = t.valor; p.seleccionando_rut = false;" class="dropdown-item ident_prefico">
                        <span class="ident_prefico">{{ t.nombre }} {{ t.desc }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Nombre -->
                <div class="form-field">
                  <label class="field-label">Nombre</label>
                  <input @focus="focused_nombre = true;" @blur="focused_nombre = false" v-model="p.nombre"
                    @input="p.nombre = $event.target.value" placeholder="Maximiliano" class="medical-input" type="text">
                </div>

                <!-- Apellidos -->
                <div class="form-field">
                  <label class="field-label">Apellidos Paterno y Materno</label>
                  <input @focus="focused_apellido1 = true;" @blur="focused_apellido1 = false" v-model="p.apellido1"
                    @input="p.apellido1 = $event.target.value" placeholder="Pérez González" class="medical-input"
                    type="text">
                </div>

                <!-- Email -->
                <div class="form-field">
                  <label class="field-label">Email</label>
                  <input :class="{ 'error': !verificar_correo(p.email) && !focused_email }" v-model="p.email"
                    @input="p.email = $event.target.value" @focus="focused_email = true;" @blur="focused_email = false"
                    placeholder="maxpe@gmail.com" class="medical-input" type="email">
                  <div v-if="!verificar_correo(p.email) && !focused_email" class="field-error">
                    Formato de email incorrecto
                  </div>
                </div>

                <!-- Teléfono -->
                <div class="form-field">
                  <label class="field-label">Teléfono</label>
                  <div class="input-group d-flex" style="position: relative;">
                    <div @click.stop="p.seleccionando_telefono = !p.seleccionando_telefono" class="input-prefix num_prefico" style="cursor: pointer; flex-shrink: 0;">
                      <img class="flag-icon num_prefico" :src="getFlagUrl(banderas.find(x => { return p.tel_prefijo == x.num }).arch)" alt="">
                      <span class="num_prefico">{{ p.tel_prefijo }}</span>
                      <svg class="num_prefico" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M6 9l6 6 6-6"></path>
                      </svg>
                    </div>

                    <input 
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      onkeypress='return event.charCode >= 48 && event.charCode <= 57' 
                      v-model="p.telefono"
                      @focus="focused_telefono = true;" 
                      @blur="focused_telefono = false"
                      @input="p.telefono = $event.target.value" 
                      placeholder="963854321" 
                      class="medical-input" 
                      type="text"
                      style="border-radius: 0 8px 8px 0; flex: 1; width: auto;">

                    <div v-if="p.seleccionando_telefono" class="custom-dropdown num_prefico">
                      <div v-for="b in banderas" :key="b.num" @click.stop="p.tel_prefijo = b.num; p.seleccionando_telefono = false;"
                        class="dropdown-item num_prefico">
                        <img class="flag-icon num_prefico" :src="getFlagUrl(b.arch)" alt="">
                        <span class="num_prefico">{{ b.num }} {{ b.nom }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Género -->
                <div class="form-field">
                  <label class="field-label">Género</label>
                  <select class="medical-select" v-model="p.sexo">
                    <option value="">Seleccione género</option>
                    <option value="f">Femenino</option>
                    <option value="m">Masculino</option>
                  </select>
                </div>

                <!-- Nacionalidad -->
                <div class="form-field">
                  <label class="field-label">Nacionalidad</label>
                  <input v-model="p.nacionalidad" @input="p.nacionalidad = $event.target.value"
                    @focus="focused_nacionalidad = true;" @blur="focused_nacionalidad = false" placeholder="Chilena"
                    class="medical-input" type="text">
                </div>

                <!-- Fecha de nacimiento -->
                <div class="form-field">
                  <label class="field-label">Fecha de nacimiento</label>
                  <div class="date-inputs">
                    <select @change="cambio_edad(p)" class="medical-select" v-model="p.fecha_nacimiento_d">
                      <option value="0">Día</option>
                      <option v-for="x in getDaysInMonth(p.fecha_nacimiento_m, p.fecha_nacimiento_a)" :value="x">{{ x }}
                      </option>
                    </select>

                    <select @change="cambio_edad(p)" class="medical-select" v-model="p.fecha_nacimiento_m">
                      <option value="0">Mes</option>
                      <option v-for="x, y in meses" :value="y + 1">{{ x }}</option>
                    </select>

                    <select @change="cambio_edad(p)" class="medical-select" v-model="p.fecha_nacimiento_a">
                      <option value="0">Año</option>
                      <option v-for="x in 120" :value="new Date().getFullYear() - x + 1">{{ new Date().getFullYear() - x
                        + 1 }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- Aseguradora -->
                <div class="form-field">
                  <label class="field-label">Aseguradora</label>
                  <select class="medical-select" v-model="p.aseguradora_id">
                    <option :value="0">Seleccionar</option>
                    <option v-for="a in aseguradoras" :value="a.id">{{ a.nombre }}</option>
                  </select>
                </div>
              </div>

              <div v-if="prestador.atributos.config.agregar_mas_pacientes != 0 && !isPrestador16"
                @click="removerPaciente(i);" class="remove-patient-btn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 6h18"></path>
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                  <path d="M8 6V4c0-1 1-2 2-2h4c0-1 1-2 2-2v2"></path>
                </svg>
                Quitar paciente
              </div>
            </b-collapse>
          </div>

          <!-- Dirección -->
          <div class="address-card">
            <div class="address-header">
              <div class="section-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9,22 9,12 15,12 15,22"></polyline>
                </svg>
              </div>
              <h3>Dirección del Servicio</h3>
            </div>

            <div class="address-form">
              <div class="address-input-container" style="position: relative;">
                <!-- INPUT -->
                <input v-show="direccion === '' || focused_direccion"
                  :placeholder="direccion === '' ? 'Avenida ClinicGo 4421' : ''" name="randomWord" autocomplete="cc-csc"
                  @input="direccion_ = $event.target.value; getDireccion();" v-model="direccion_"
                  @focus="focused_direccion = true" class="medical-input dont-close-direccion" type="text" />

                <!-- ❌ BOTÓN PARA LIMPIAR -->
                <button v-if="direccion !== '' && !focused_direccion" @click="limpiarDireccion" type="button"
                  class="clear-button"
                  style="position: absolute; right: 10px; top: 8px; background: none; border: none; cursor: pointer;">
                  ❌
                </button>

                <!-- DIRECCIÓN MOSTRADA -->
                <div v-if="direccion !== '' && !focused_direccion" class="address-display" style="padding-right: 24px;"
                  >
                  {{ direccion }}
                </div>

                <!-- DROPDOWN DE OPCIONES -->
                <div class="dont-close-direccion address-dropdown" v-if="focused_direccion">
                  <div class="dont-close-direccion" v-if="opciones_calles.length > 0 && /\d/.test(direccion_)">
                    <div class="dont-close-direccion dropdown-item" v-for="o in opciones_calles"
                      @click="direccion = o.calle + ' ' + o.numero; direccion_ = ''; focused_direccion = false; lat = o.lat; lon = o.lon;">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                      {{ o.calle }} {{ o.numero }}
                    </div>
                  </div>
                  <div class="dont-close-direccion dropdown-item" v-else>
                    Por favor, escribe <strong>calle y número</strong>.
                  </div>
                </div>
              </div>


              <div class="form-field">
                <label class="field-label">Comuna</label>
                <div class="comuna-display">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  {{comunas.filter(x => { return x.id == comuna })[0].Nombre}}
                </div>
              </div>

              <div class="form-field full-width">
                <label class="field-label">Tipo de vivienda</label>
                <div class="property-type-buttons">
                  <button
                    :style="{ 'color': depto == 1 ? prestador.atributos.assets.colors.primary : '#fff', 'border-color': prestador.atributos.assets.colors.primary, 'background-color': depto != 1 ? prestador.atributos.assets.colors.primary : '#fff' }"
                    @click="depto = 0" :class="{ 'active': depto == 0 }" class="property-type-btn">
                    Casa
                  </button>
                  <button
                    :style="{ 'color': depto == 0 ? prestador.atributos.assets.colors.primary : '#fff', 'border-color': prestador.atributos.assets.colors.primary, 'background-color': depto != 0 ? prestador.atributos.assets.colors.primary : '#fff' }"
                    @click="depto = 1" :class="{ 'active': depto == 1 }" class="property-type-btn">
                    Departamento
                  </button>
                </div>
              </div>

              <div class="form-field" v-if="depto == 1">
                <label class="field-label">Número de departamento</label>
                <input placeholder="A32" maxlength="8" v-model="n_depto" @focus="focused_n_depto = true;"
                  @blur="focused_n_depto = false" class="medical-input" type="text">
              </div>

              <div class="form-field full-width">
                <label class="field-label">Información adicional (opcional)</label>
                <input placeholder="Condominio CG, portón azul, etc." maxlength="119" v-model="info_adicional"
                  class="medical-input" type="text">
              </div>
            </div>
          </div>
        </div>

        <div class="navigation-buttons">
          <button @click="estado--" class="secondary-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5"></path>
              <path d="M12 19l-7-7 7-7"></path>
            </svg>
            Anterior
          </button>
          <button @click="checkout_datos_paciente()"
            :style="{ 'background-color': prestador.atributos.assets.colors.primary, 'opacity': this.puedeContinuarError == '' ? '1' : '0.5' }"
            class="primary-btn">
            Siguiente
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Estado 4: Subir Orden(es) Médicas -->
      <div v-if="estado == 4 && !loading_transferencia && !orden_enviada" class="step-container">
        <div class="step-header">
          <div class="step-number" :style="{
            backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
          }">5</div>
          <h2 class="step-title">Orden(es) Médicas</h2>
          <p class="step-subtitle">Incluye las órdenes médicas necesarias para los exámenes</p>
        </div>

        <div class="prescriptions-container">
          <div v-for="(p, i) in examenes_agregados" :key="i" class="prescription-card">
            <div class="prescription-header">
              <div class="status-indicator">
                <div
                  v-if="((p.examenes.some(x => { return x.requiere_orden == 1 }) || p.examenes.length == 0)) && p.orden_medica == null"
                  class="status-warning">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0-3.42 0z">
                    </path>
                    <line x1="12" y1="9" x2="12" y2="13"></line>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                  </svg>
                </div>
                <div v-else class="status-success">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22,4 12,14.01 9,11.01"></polyline>
                  </svg>
                </div>
              </div>

              <div class="patient-info">
                <div class="patient-avatar">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <span class="patient-name">{{ p.nombre }} {{ p.apellido1 }}</span>
              </div>
            </div>

            <div class="prescription-actions">
              <div v-if="pacienteRequiereReceta(p) || p.examenes.length == 0">
                <input multiple @change="change_file(i)" :id="'file' + i" :ref="'file' + i" type="file"
                  accept="image/*, application/pdf" class="file-input" />
                <label :style="{ 'background-color': prestador.atributos.assets.colors.primary }" class="upload-btn"
                  :for="'file' + i">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                    <circle cx="12" cy="13" r="4"></circle>
                  </svg>
                  Subir orden médica
                </label>
              </div>

              <div v-else class="not-applicable">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
                No aplica
              </div>
            </div>

            <div v-if="p.orden_medica && p.orden_medica.length > 0" class="uploaded-files">
              <h4 class="files-title">Archivos subidos</h4>
              <div class="files-list">
                <div v-for="(o, j) in p.orden_medica" :key="j" class="file-item">
                  <div class="file-info">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14,2 14,8 20,8"></polyline>
                      <line x1="16" y1="13" x2="8" y2="13"></line>
                      <line x1="16" y1="17" x2="8" y2="17"></line>
                      <polyline points="10,9 9,9 8,9"></polyline>
                    </svg>
                    <span class="file-name">{{ o.nombre }}</span>
                  </div>
                  <button @click="removerOrdenMedica(i, j)" class="remove-file-btn">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="prestador.atributos.config.mensaje_orden_medica_html != undefined && prestador.atributos.config.mensaje_orden_medica_html != ''"
            class="prescription-info">
            <div v-html="prestador.atributos.config.mensaje_orden_medica_html"></div>
          </div>
        </div>

        <div class="navigation-buttons">
          <button @click="estado--" class="secondary-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5"></path>
              <path d="M12 19l-7-7 7-7"></path>
            </svg>
            Anterior
          </button>
          <button @click="transferencia()" :style="{ 'background-color': prestador.atributos.assets.colors.primary }"
            class="primary-btn">
            Enviar orden
          </button>
        </div>
      </div>

      <!-- Estado de carga -->
      <div v-if="loading_transferencia && !orden_enviada" class="loading-container">
        <div class="loading-content">
          <Loader :height="100" :width="100" />
          <h3>Procesando su orden...</h3>
          <p>Por favor espere mientras enviamos su solicitud</p>
        </div>
      </div>

      <!-- Orden enviada con éxito -->
      <div v-if="orden_enviada" class="success-container">
        <div class="success-content">
          <div class="success-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22,4 12,14.01 9,11.01"></polyline>
            </svg>
          </div>
          <h2>Hora agendada con éxito!</h2>
          <p>Su solicitud ha sido procesada correctamente. Pronto recibirá confirmación del servicio.</p>

          <div class="success-actions">
            <button @click="crearNuevaOrden()"
              :style="{ 'background-color': prestador.atributos.assets.colors.primary }" class="primary-btn">
              Crear nueva orden
            </button>
            <button @click="limpiarTodo()" class="secondary-btn">
              Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Fuse from "fuse.js";
import axios from 'axios';
import { funcionesCalculoCosto } from '../helpers/funciones';
import Loader from '@/components/Loader.vue';
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';

export default {
  name: 'AgendarAtencion',
  components: {
    Loader,
    SideNav,
    TopNav
  },
  data() {
    return {
      default_id: 0,
      estado: -1,
      examenes_agregados: [{
        nombre: '',
        tipo_identificador: 'rut',
        nacionalidad: 'Chilena',
        sexo: '',
        fecha_nacimiento_a: 0,
        fecha_nacimiento_m: 0,
        fecha_nacimiento_d: 0,
        aseguradora_id: 1,
        apellido1: '',
        email: '',
        rut: '',
        telefono: '',
        tel_prefijo: '+56',
        seleccionando_telefono: false,
        seleccionando_rut: false,
        orden_medica: null,
        examenes: [],
        visible: true
      }],

      /* Primer estado */
      resultado_fuse_comuna: [],
      fComunas: null,
      comuna_buscado: '',
      comuna: 0,

      /* Segundo estado */
      valores_codigo: [],
      asegurador_default: 1,
      agregando_examen_paciente: -1,
      buscando_examen: '',
      buscando_examen_principal: '',
      resultado_fuse_examen: [],
      fExamen: null,

      /* Tercer estado */
      loading: true,
      datos: [],
      alerta: false,
      horasDisponibles: [],
      descripcion: '',
      nombre: '',
      mostrar_mas: false,
      horasDisponiblesC: [],
      combinaciones: [],
      tiSelected: -1,
      tfSelected: -1,
      categorias_selected_c: [],
      viendoMes: 0,
      viendoAño: 0,
      selectedDia: -1,
      selectedMes: -1,
      selectedAño: -1,
      selected_prioridad: -1,
      selected_recargo_porcentaje: 0,
      selected_recargo_suma: 0,
      buscadoDia: 0,
      buscadoMes: 0,
      buscadoAño: 0,
      hoyMes: 0,
      hoyDia: 0,
      hoyAño: 0,
      modalState: 0,
      hoy: 0,
      mapping: [6, 0, 1, 2, 3, 4, 5],
      meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      dias: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'],
      dias_av: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
      cargando_disponibles: false,
      cargando_combinaciones: false,
      buscadoHoras: false,
      disponibilidad_diaria: {},

      /* cuarto estado */
      direccion: '',
      apellido1: '',
      apellido2: '',
      nombre: '',
      depto: 1,
      rut: '',
      email: '',
      telefono: '',
      n_depto: '',
      info_adicional: '',
      alerta: false,
      fexamenes: null,
      agregando_examen: false,
      visible: [true, false, false, false],
      focused_direccion: false,
      focused_apellido1: false,
      focused_apellido2: false,
      focused_nombre: false,
      focused_rut: false,
      focused_email: false,
      focused_telefono: false,
      focused_n_depto: false,
      focused_info_adicional: false,
      focused_nacionalidad: false,
      pacientes: [],
      examen_buscado: '',
      tipo_identificador: [
        { nombre: 'Rut', valor: 'rut', desc: '(RUT nacional)' },
        { nombre: 'Pasaporte', valor: 'pasaporte', desc: '(Pasaporte extranjero)' },
        { nombre: 'DNI', valor: 'dni', desc: '(DNI extranjero)' },
      ],
      banderas: [
        { arch: 'cl.svg', num: '+56', nom: 'Chile' },
        { arch: 'ar.svg', num: '+54', nom: 'Argentina' },
        { arch: 'br.svg', num: '+55', nom: 'Brasil' },
        { arch: 'us.svg', num: '+1', nom: 'Estados Unidos' },
        { arch: 'co.svg', num: '+57', nom: 'Colombia' },
        { arch: 'mx.svg', num: '+52', nom: 'Mexico' },
        { arch: 'pe.svg', num: '+51', nom: 'Peru' },
        { arch: 'uy.svg', num: '+598', nom: 'Uruguay' },
        { arch: 'bo.svg', num: '+591', nom: 'Bolivia' },
      ],
      opciones_calles: [],
      editando_paciente: 0,
      direccion_: '',
      lat: 0,
      lon: 0,
      info_adicional: '',
      np: 1,
      loading_transferencia: false,
      orden_enviada: false,
      es_principal: false,
      estados: ['Anulado', 'Citado', 'Confirmado', 'Atendido', 'No Atendido'],
      prestadores: [],
      selectedPrestador: 1,
      loading_prestador: false,
      subiendo_archivo: false,
      datosGuardados: null,
    }
  },
  methods: {
    ...mapActions(['reconfigure']),
    ...funcionesCalculoCosto,

    // Método para seleccionar horario
    selectTimeSlot(horario) {
      this.selected_prioridad = horario.prioridad;
      this.selected_recargo_suma = horario.recargo_suma;
      this.selected_recargo_porcentaje = horario.recargo_porcentaje;
      this.tiSelected = horario.desde;
      this.tfSelected = horario.hasta;
      this.categorias_selected_c = horario.categorias;
    },

    // Método para seleccionar día mejorado
    seleccionarDia(d, m, a) {
      let dia = new Date(a, m, d);
      let hoyDia = new Date(this.hoy.getFullYear(), this.hoy.getMonth(), this.hoy.getDate());

      if (dia.getTime() >= hoyDia.getTime()) {
        this.selectedDia = d;
        this.selectedMes = m;
        this.selectedAño = a;
        this.tiSelected = -1;
        this.tfSelected = -1;
        this.combinaciones = [];
        this.verDisponibilidadSiPuede();
      }
    },

    calculateAge(yearOfBirth, monthOfBirth, dayOfBirth) {
      const today = new Date();
      const birthDate = new Date(yearOfBirth, monthOfBirth - 1, dayOfBirth);

      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age;
    },
autocompleteClient(paciente) {
  if (!paciente.rut) {
    return;
  }

  const endpoint = `api/admin/autocomplete_cliente?rut=${paciente.rut}`;

  axios.get(window.hostname + endpoint)
    .then(response => {
      if (response.status === 200) {
        const clientData = response.data.cliente_data;

        paciente.nombre = clientData.nombre;
        paciente.apellido1 = clientData.apellido1;
        paciente.apellido2 = clientData.apellido2;
        
        paciente.telefono = clientData.telefono ? clientData.telefono.replace(/^\+56/, '') : '';
        
        paciente.email = clientData.email;
        this.direccion = clientData.direccion_ultima_orden;
        this.departamento = clientData.departamento_ultima_orden;
        this.n_depto = clientData.n_depto_ultima_orden;

        if (clientData.fecha_nacimiento) {
          const [year, month, day] = clientData.fecha_nacimiento.split('T')[0].split('-');
          paciente.fecha_nacimiento_a = parseInt(year, 10);
          paciente.fecha_nacimiento_m = parseInt(month, 10);
          paciente.fecha_nacimiento_d = parseInt(day, 10);
        }

        paciente.aseguradora_id = clientData.aseguradora_id;
        paciente.sexo = clientData.sexo_biologico;
      }
    })
    .catch(error => {
      console.error(error);
    });
},

    guardarDatosActuales() {
      return {
        examenes_agregados: JSON.parse(JSON.stringify(this.examenes_agregados)),
        comuna: this.comuna,
        direccion: this.direccion,
        depto: this.depto,
        n_depto: this.n_depto,
        info_adicional: this.info_adicional,
        lat: this.lat,
        lon: this.lon
      };
    },

    reutilizarDatos(datosGuardados) {
      this.examenes_agregados = JSON.parse(JSON.stringify(datosGuardados.examenes_agregados));
      this.comuna = datosGuardados.comuna;
      this.direccion = datosGuardados.direccion;
      this.depto = datosGuardados.depto;
      this.n_depto = datosGuardados.n_depto;
      this.info_adicional = datosGuardados.info_adicional;
      this.lat = datosGuardados.lat;
      this.lon = datosGuardados.lon;

      this.estado = 0;
      this.orden_enviada = false;
      this.loading_transferencia = false;

      this.selectedDia = -1;
      this.selectedMes = -1;
      this.selectedAño = -1;
      this.tiSelected = -1;
      this.tfSelected = -1;

      this.$notify({
        group: 'foo',
        title: '¡Datos reutilizados!',
        text: 'Puedes modificar cualquier dato antes de enviar la nueva orden',
        type: 'success'
      });
    },

    crearNuevaOrden() {
      this.estado = 0;
      this.orden_enviada = false;
      this.loading_transferencia = false;
    },

    limpiarTodo() {
      this.$router.push({ name: 'Ordenes' });
    },

    removerExamen(paciente, examen) {
      this.examenes_agregados[paciente].examenes.splice(examen, 1);
    },

    async onSelectPrestadorChange() {
      this.loading_prestador = true;
      await this.reconfigure({ prestador_id: this.selectedPrestador });
      this.examenes_agregados = [{
        nombre: '',
        tipo_identificador: 'rut',
        nacionalidad: 'Chilena',
        sexo: '',
        fecha_nacimiento_a: 0,
        fecha_nacimiento_m: 0,
        fecha_nacimiento_d: 0,
        aseguradora_id: 1,
        apellido1: '',
        email: '',
        rut: '',
        telefono: '',
        tel_prefijo: '+56',
        seleccionando_telefono: false,
        seleccionando_rut: false,
        orden_medica: null,
        examenes: this.examenes.length > 0 ? [this.examenes[0].id] : [],
        visible: true
      }];
      this.fExamen = new Fuse(this.examenes, { keys: ["nombre"] });
      this.loading_prestador = false;
    },

    transferencia() {
      if (this.loading_transferencia) return;
      this.datosGuardados = this.guardarDatosActuales();

      const ordenData = {
        examenes: this.examenes_agregados,
        dia: this.selectedDia,
        mes: this.selectedMes,
        año: this.selectedAño,
        comuna_id: this.comuna,
        desde: this.tiSelected,
        hasta: this.tfSelected,
        duracion_bloque: this.getDuracionSeleccionada(),
        direccion: this.direccion,
        departamento: this.depto,
        n_depto: this.n_depto,
        orden: this.examenes_agregados.map(p => ({
          ...p,
          asegurador: p.aseguradora_id || p.asegurador
        })),
        recargo_porcentaje: this.selected_recargo_porcentaje,
        recargo_suma: this.selected_recargo_suma,
        prioridad: this.selected_prioridad,
        codigo: this.codigo,
        lat: this.lat,
        lon: this.lon,
        info_ad: this.info_adicional,
        prestador_id: this.prestador.id != 1 ? this.prestador.id : this.selectedPrestador,
        config_id: this.config_id
      };

      this.loading_transferencia = true;
      const formData = new FormData();
      formData.append("document", new Blob([JSON.stringify(ordenData)], { type: 'application/json' }));

      axios.post(`${window.hostname}api/prueba2`, formData)
        .then(response => {
          this.loading_transferencia = false;
          this.orden_enviada = true;
          this.$notify({
            group: 'foo',
            title: '¡Éxito!',
            text: 'Hora agendada correctamente',
            type: 'success'
          });
        })
        .catch(error => {
          this.loading_transferencia = false;
          this.$notify({
            group: 'foo',
            title: '¡Error!',
            text: error.response?.data?.message || 'Ha habido un error con la orden',
            type: 'error'
          });
        });
    },

    getDuracionSeleccionada() {
      const horarioSeleccionado = this.horasDisponiblesC.find(h =>
        h.desde === this.tiSelected &&
        h.dia === this.selectedDia &&
        h.mes === this.selectedMes &&
        h.año === this.selectedAño
      );

      return horarioSeleccionado?.duracion || 60;
    },

    getDireccion() {
      if (/\d/.test(this.direccion_)) {
        axios.post(window.hostname + 'api/get_direccion', {
          comuna: this.comunas.filter(x => { return x.id == this.comuna })[0].Nombre,
          calle: this.direccion_
        })
          .then(r => {
            this.opciones_calles = r.data.opciones;
          })
          .catch(e => {
            console.log(e);
          });
      }
    },

    limpiarDireccion() {
      this.direccion = '';
      this.direccion_ = '';
      this.focused_direccion = true;
    },

    close(e) {
      if (!(e.target.classList.contains('search-exam-popup') || e.target.classList.contains('dont-close-exam')) && this.focused_exam) {
        this.focused_exam = false;
        this.examen_buscado = '';
      }

      if (!(e.target.classList.contains('dont-close-direccion')) && this.focused_direccion) {
        if (this.opciones_calles.length > 0) {
          this.direccion = this.opciones_calles[0].calle + ' ' + this.opciones_calles[0].numero;
          this.lat = this.opciones_calles[0].lat;
          this.lon = this.opciones_calles[0].lon;
        } else {
          this.direccion = this.direccion_;
        }

        this.focused_direccion = false;
        this.direccion_ = '';
      }

      if (!e.target.closest('.num_prefico')) {
        for (var j = 0; j < this.examenes_agregados.length; j++) {
          this.examenes_agregados[j].seleccionando_telefono = false;
        }
      }

      if (!e.target.closest('.ident_prefico')) {
        for (var j = 0; j < this.examenes_agregados.length; j++) {
          this.examenes_agregados[j].seleccionando_rut = false;
        }
      }
    },

    verificar_correo(c) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (c != '') {
        return re.test(c) ? true : false;
      }
      return true;
    },

    getFlagUrl(pic) {
      return require('../assets/banderas/' + pic);
    },

    getDaysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },

    verificar_rut(r) {
      function dv(T) {
        var M = 0, S = 1;
        for (; T; T = Math.floor(T / 10)) {
          S = (S + T % 10 * (9 - M++ % 6)) % 11;
        }
        return S ? S - 1 : 'k';
      }

      function validaRut(rutCompleto) {
        if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) {
          return false;
        }

        var tmp = rutCompleto.split('-');
        var digv = tmp[1];
        var rut = tmp[0];

        if (digv == 'K') {
          digv = 'k';
        }

        return (dv(rut) == digv) ? true : false;
      }

      return validaRut(r);
    },

    removerOrdenMedica(paciente, archivo) {
      if (this.examenes_agregados[paciente].orden_medica == undefined || !Array.isArray(this.examenes_agregados[paciente].orden_medica)) {
        return;
      }

      this.examenes_agregados[paciente].orden_medica.splice(archivo, 1);
    },

    async change_file(i) {
      const file = this.$refs['file' + i][0].files[0];

      if (['jpg', 'png', 'jpeg', 'pdf'].includes(file.name.split('.').pop())) {
        try {
          this.subiendo_archivo = true;
          const formData = new FormData();
          formData.append('file', file);

          const response = await axios.post(window.hostname + 'api/admin/preupload_recetas', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          this.subiendo_archivo = false;
          const token = response.data.token;
          let obj = { token: token, nombre: file.name };

          if (this.examenes_agregados[i].orden_medica == undefined || !Array.isArray(this.examenes_agregados[i].orden_medica)) {
            this.examenes_agregados[i].orden_medica = [obj];
          } else {
            this.examenes_agregados[i].orden_medica.push(obj);
          }

          this.$gtag.event('ordenmedica_subir_archivo', {
            'event_category': this.prestador.nombre,
            'event_label': 'correcto',
            'value': 1
          });
        } catch (error) {
          this.subiendo_archivo = false;
          this.error_subiendo_archivo = true;
          console.error('File upload failed:', error);
        }
      } else {
        this.$gtag.event('ordenmedica_subir_archivo', {
          'event_category': this.prestador.nombre,
          'event_label': 'incorrecto',
          'value': 1
        });
        this.error_archivo = true;
      }
    },

    pacienteRequiereReceta(paciente) {
      let requiere = false;

      if (paciente.examenes.length == 0 && this.prestador.atributos.config.orden_medica_obligatoria == 1) {
        return true;
      }

      for (var examen of paciente.examenes) {
        if (this.examenes.find(z => { return z.id == examen }).requiere_orden == 1) {
          requiere = true;
          break;
        }
      }

      return requiere;
    },

    sumarMes() {
      if (this.viendoMes == 11) {
        this.viendoMes = 0;
        this.viendoAño += 1;
      } else {
        this.viendoMes += 1;
      }

      this.getDisponiblesMes(this.viendoMes, this.viendoAño);
    },

    restarMes() {
      if (this.viendoMes == 0) {
        this.viendoMes = 11;
        this.viendoAño -= 1;
      } else {
        this.viendoMes -= 1;
      }

      this.getDisponiblesMes(this.viendoMes, this.viendoAño);
    },

    click_servicio(serv, pos) {
      // Para prestador 16, no permitir agregar más de un examen
      if (this.isPrestador16 && this.examenes_agregados[pos].examenes.length >= 1) {
        this.$notify({
          group: 'foo',
          title: '¡Error!',
          text: 'Solo se permite un examen por paciente para este prestador',
          type: 'error'
        });
        return;
      }
      this.examenes_agregados[pos].examenes.push(serv.id);
    },

    checkout() {
      // Validación para prestador 16
      if (this.isPrestador16) {
        const tieneMasDeUnExamen = this.examenes_agregados.some(p => p.examenes.length > 1);
        const tienePacientesSinExamen = this.examenes_agregados.some(p => p.examenes.length === 0);

        if (tieneMasDeUnExamen) {
          this.$notify({
            group: 'foo',
            title: '¡Error!',
            text: 'Para este prestador solo se permite 1 examen por paciente',
            type: 'error'
          });
          return;
        }

        if (tienePacientesSinExamen) {
          this.$notify({
            group: 'foo',
            title: '¡Error!',
            text: 'Todos los pacientes deben tener al menos 1 examen',
            type: 'error'
          });
          return;
        }
      }

      // Validación general para todos los prestadores
      if (this.examenes_agregados.length === 0) {
        this.$notify({
          group: 'foo',
          title: '¡Error!',
          text: 'Debes agregar al menos un examen',
          type: 'error'
        });
        return;
      }

      // Si pasa todas las validaciones, continuar
      this.estado = 2;
      this.disponibilidad_diaria = {};
      this.horasDisponiblesC = [];
      this.selectedAño = -1;
      this.selectedDia = -1;
      this.selectedMes = -1;
      this.getDisponiblesMes(this.hoyMes, this.hoyAño);
    },

    checkout_fecha_y_hora() {
      if (this.selectedDia != -1 && this.selectedMes != -1 && this.selectedAño != -1 && this.tiSelected != -1 && this.tfSelected != -1 && this.selected_prioridad != -1 && this.selected_recargo_porcentaje != -1 && this.selected_recargo_suma != -1) {
        this.estado = 3;
      }
    },

    checkout_datos_paciente() {
      if (this.puedeContinuarError != '') {
        this.$notify({
          group: 'foo',
          title: '¡Error!',
          text: this.puedeContinuarError,
          type: 'error'
        });
        return;
      }

      if (this.selectedDia != -1 && this.selectedMes != -1 && this.selectedAño != -1 && this.tiSelected != -1 && this.tfSelected != -1 && this.selected_prioridad != -1 && this.selected_recargo_porcentaje != -1 && this.selected_recargo_suma != -1) {
        this.estado = 4;
      }
    },

    _blur() {
      setTimeout(() => { this.agregando_examen_paciente = -1 }, 200);
    },

    agregarPaciente() {
      // Para prestador 16, no permitir más de un paciente
      if (this.isPrestador16) {
        this.$notify({
          group: 'foo',
          title: '¡Error!',
          text: 'Solo se permite un paciente para este prestador',
          type: 'error'
        });
        return;
      }

      this.examenes_agregados.push({
        nombre: '',
        tipo_identificador: 'rut',
        nacionalidad: 'Chilena',
        sexo: '',
        fecha_nacimiento_a: 0,
        fecha_nacimiento_m: 0,
        fecha_nacimiento_d: 0,
        aseguradora_id: 1,
        apellido1: '',
        email: '',
        rut: '',
        telefono: '',
        tel_prefijo: '+56',
        seleccionando_telefono: false,
        seleccionando_rut: false,
        orden_medica: null,
        examenes: [],
        visible: true
      });
    },

    removerPaciente(pos) {
      // Para prestador 16, no permitir remover si solo hay un paciente
      if (this.isPrestador16 && this.examenes_agregados.length <= 1) {
        this.$notify({
          group: 'foo',
          title: '¡Error!',
          text: 'No puedes eliminar el único paciente para este prestador',
          type: 'error'
        });
        return;
      }

      if (this.examenes_agregados.length != 1) {
        this.examenes_agregados.splice(pos, 1);
      } else {
        this.$notify({
          group: 'foo',
          title: '¡Error!',
          text: 'No puedes eliminar a todos los pacientes',
          type: 'error'
        });
      }
    },

    getDisponiblesMes(m, y) {
      if (this.estado != 2) {
        return;
      }

      const nextMonth = new Date(y, m + 1, 1);
      const lastDayOfMonth = new Date(nextMonth.getTime() - 1);

      if (this.disponibilidad_diaria.hasOwnProperty(lastDayOfMonth.getDate() + '-' + (m + 1) + '-' + y)) {
        return;
      }

      let exs_ = this.examenes_agregados.length > 0 ?
        (this.examenes_agregados.length > 1 ?
          this.examenes_agregados.reduce((x, y) => { return x.concat(y.examenes) }, []) :
          this.examenes_agregados[0].examenes).map(j => { return { id: j } })
        : this.categorias_selected.map(x => { return { id: this.examenes.find(y => { return y.categoria_id == x.id }).id } });

      axios.post(window.hostname + 'api/admin/getDisponiblesMes', {
        prestador_id: this.prestador.id != 1 ? this.prestador.id : this.selectedPrestador,
        examenes: exs_,
        mes: m,
        año: y,
        comuna_id: this.comuna,
      })
        .then(resp => {
          this.disponibilidad_diaria = Object.assign({}, resp.data.horarios_posibles, this.disponibilidad_diaria);
        })
        .catch(e => {
          console.log(e);
        });
    },

    verDisponibilidadSiPuede() {
      this.cargando_disponibles = true;

      axios.post(window.hostname + '/api/admin/getDisponiblesHorario', {
        prestador_id: this.prestador.id != 1 ? this.prestador.id : this.selectedPrestador,
        examenes: this.examenes_agregados.length > 0 ?
          (this.examenes_agregados.length > 1 ?
            this.examenes_agregados.reduce((x, y) => { return x.concat(y.examenes) }, []) :
            this.examenes_agregados[0].examenes).map(j => { return { id: j } })
          : this.categorias_selected.map(x => { return { id: this.examenes.find(y => { return y.categoria_id == x.id }).id } }),
        dia: this.selectedDia,
        mes: this.selectedMes,
        año: this.selectedAño,
        comuna_id: this.comuna,
      })
        .then(resp => {
          this.horasDisponibles = resp.data.horarios_posibles;
          this.cargando_disponibles = false;
          this.buscadoDia = this.selectedDia;
          this.buscadoMes = this.selectedMes;
          this.buscadoAño = this.selectedAño;
        })
        .catch(e => {
          this.cargando_disponibles = false;
          console.log(e);
        });
    },

    timeConvert(n) {
      var num = n;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return (rhours < 10 ? '0' : '') + rhours + ":" + (rminutes < 10 ? '0' : '') + rminutes + "";
    },

    UltimoDia(y, m) {
      return new Date(y, m + 1, 0).getDate();
    },

    clickearComuna(comuna) {
      if (this.comunas_usadas.some(x => { return x.id == comuna.id })) {
        this.comuna = comuna.id;
        this.estado = 1;
      } else {
        this.$notify({
          group: 'foo',
          title: '¡Error!',
          text: 'Comuna inhabilitada',
          type: 'error'
        });
      }
    },

    get_prestadores() {


      axios.get(window.hostname + '/api/admin/get_prestadores')
        .then(r => {

          this.prestadores = r.data.prestadores
        })
        .catch(r => {


        })

    },

    formatNum(num) {
      return new Intl.NumberFormat('es-CL').format(num);
    },

    getExamen(id) {
      return this.examenes.find(e => e.id === id) || { nombre: 'Examen no encontrado' };
    },

    agruparExamenes(examenesArray) {
      if (!examenesArray) return [];
      const grupos = {};
      examenesArray.forEach(id => {
        if (!grupos[id]) {
          grupos[id] = { id: id, cantidad: 0 };
        }
        grupos[id].cantidad++;
      });
      return Object.values(grupos);
    },

    agregarInstanciaExamen(pacienteIndex, examenId) {
      if (this.examenes_agregados[pacienteIndex]) {
        this.examenes_agregados[pacienteIndex].examenes.push(examenId);
      }
    },

    removerInstanciaExamen(pacienteIndex, examenId) {
      if (this.examenes_agregados[pacienteIndex]) {
        const index = this.examenes_agregados[pacienteIndex].examenes.indexOf(examenId);
        if (index !== -1) {
          this.examenes_agregados[pacienteIndex].examenes.splice(index, 1);
        }
      }
    },

    removerExamenSeleccionado(pacienteIndex, examenId) {
      if (this.examenes_agregados[pacienteIndex]) {
        this.examenes_agregados[pacienteIndex].examenes = this.examenes_agregados[pacienteIndex].examenes.filter(id => id !== examenId);
      }
    },

    cambio_edad(paciente) {
      // Lógica para cambio de edad si es necesaria
    }
  },
  computed: {
    ...mapGetters([
      'prestador',
      'comunas',
      'comunas_usadas',
      'aseguradoras',
      'categorias',
      'costo_servicio_pendiente',
      'examenes',
      'prestador_id',
      'categorias_selected',
      'codigo',
    ]),

    // Computed para verificar si es prestador 16
    isPrestador16() {
      const currentPrestadorId = this.prestador.id != 1 ? this.prestador.id : this.selectedPrestador;
      return currentPrestadorId === 16;
    },

    // Computed para generar las semanas del calendario correctamente
    calendarWeeks() {
      const weeks = [];
      const firstDay = new Date(this.viendoAño, this.viendoMes, 1);
      const lastDay = new Date(this.viendoAño, this.viendoMes + 1, 0);
      const startDate = new Date(firstDay);

      // Ajustar al primer día de la semana (Lunes = 1, Domingo = 0)
      const dayOfWeek = firstDay.getDay();
      const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      startDate.setDate(startDate.getDate() - daysToSubtract);

      let weekIndex = 0;
      let currentDate = new Date(startDate);

      while (weekIndex < 6) { // Máximo 6 semanas
        const week = {
          weekIndex,
          days: []
        };

        for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
          const day = currentDate.getDate();
          const month = currentDate.getMonth();
          const year = currentDate.getFullYear();
          const isCurrentMonth = month === this.viendoMes && year === this.viendoAño;
          const isToday = day === this.hoyDia && month === this.hoyMes && year === this.hoyAño;
          const isSelected = day === this.selectedDia && month === this.selectedMes && year === this.selectedAño;
          const availabilityKey = `${day}-${month + 1}-${year}`;
          const isAvailable = this.disponibilidad_diaria[availabilityKey] === 1;
          const isUnavailable = this.disponibilidad_diaria[availabilityKey] === 0;

          week.days.push({
            key: `${year}-${month}-${day}`,
            day,
            month,
            year,
            isToday,
            isSelected,
            isAvailable: isCurrentMonth && isAvailable,
            isUnavailable: isCurrentMonth && isUnavailable,
            isEmpty: false,
            isOtherMonth: !isCurrentMonth
          });

          currentDate.setDate(currentDate.getDate() + 1);
        }

        weeks.push(week);

        // Si ya pasamos el último día del mes y tenemos al menos 4 semanas, podemos parar
        if (currentDate > lastDay && weekIndex >= 3) {
          break;
        }

        weekIndex++;
      }

      return weeks;
    },

    puedeContinuarError() {
      for (let i = 0; i < this.examenes_agregados.length; i++) {
        const paciente = this.examenes_agregados[i];
        const nombrePaciente = paciente.nombre.length > 1 ? paciente.nombre : 'Paciente ' + (i + 1);

        const datosCompletos =
          paciente.nombre.length > 1 &&
          paciente.email.length > 2 &&
          paciente.apellido1.length > 1 &&
          paciente.telefono.length > 6 &&
          paciente.nacionalidad.length > 1 &&
          this.verificar_correo(paciente.email);

        if (!datosCompletos) {
          return `Hay pacientes con información incompleta. (${nombrePaciente}).`;
        }

        if (!['f', 'm'].includes(paciente.sexo)) {
          return `${nombrePaciente} no tiene sexo seleccionado.`;
        }

        if (
          paciente.fecha_nacimiento_a === 0 ||
          paciente.fecha_nacimiento_m === 0 ||
          paciente.fecha_nacimiento_d === 0
        ) {
          return `${nombrePaciente} no tiene fecha de nacimiento seleccionada.`;
        }

        if (paciente.examenes.length === 0 && this.examenes_agregados.length !== 0) {
          return `Todos los pacientes deben tener al menos un examen. (${nombrePaciente} no tiene).`;
        }

        const aseguradoraValida = this.aseguradoras.some(z => z.id === paciente.aseguradora_id);
        if (!aseguradoraValida) {
          return `${nombrePaciente} no tiene aseguradora seleccionada.`;
        }

        if (paciente.rut.length <= 4) {
          return `${nombrePaciente} debe ingresar rut o pasaporte (5 o más caracteres).`;
        }

        if (!(this.verificar_rut(paciente.rut) || paciente.tipo_identificador !== 'rut')) {
          return `${nombrePaciente} tiene que tener un rut o pasaporte válido.`;
        }

        if (this.prestador.atributos.config.requiere_verificar_ruts === 1) {
          if (paciente.cargando_rut === true) {
            return 'Se deben verificar todos los pacientes.';
          }

          if (paciente.habilitado !== 1) {
            return 'Hay ruts que no son admisibles.';
          }
        }

        const edadMinima = this.prestador.atributos.config.edad_minima;
        if (edadMinima !== undefined) {
          const edad = this.calculateAge(
            paciente.fecha_nacimiento_a,
            paciente.fecha_nacimiento_m,
            paciente.fecha_nacimiento_d
          );
          if (edad < edadMinima) {
            return `Todos los pacientes deben tener ${edadMinima} años o más.`;
          }
        }
      }

      if (this.direccion.length < 3) {
        return 'Falta agregar dirección.';
      }

      return '';
    },

    mostrar_mañana() {
      if (this.prestador.atributos.config.mostrar_primero_horas_hasta != undefined) {
        if (this.mostrar_mas) {
          return this.horasDisponiblesC.some(x => { return x.hasta < 720 });
        }

        return this.horasDisponiblesC.some(x => { return x.hasta < 720 && x.hasta < this.prestador.atributos.config.mostrar_primero_horas_hasta });
      }

      return this.horasDisponiblesC.some(x => { return x.hasta < 720 && x.hasta });
    },

    mostrar_tarde() {
      if (this.prestador.atributos.config.mostrar_primero_horas_hasta != undefined) {
        if (this.mostrar_mas) {
          return this.horasDisponiblesC.some(x => { return x.desde >= 720 });
        }

        return this.horasDisponiblesC.some(x => { return x.desde >= 720 && x.hasta < this.prestador.atributos.config.mostrar_primero_horas_hasta });
      }

      return this.horasDisponiblesC.some(x => { return x.desde >= 720 });
    },

    nombres() {
      let ret = [];

      for (var i = 0; i < this.horasDisponiblesC.length; i++) {
        if (!ret.some(x => { return x.id == this.horasDisponiblesC[i].nombre + this.horasDisponiblesC[i].recargo_suma + this.horasDisponiblesC[i].recargo_porcentaje })) {
          ret.push({
            id: this.horasDisponiblesC[i].nombre + this.horasDisponiblesC[i].recargo_suma + this.horasDisponiblesC[i].recargo_porcentaje,
            nombre: this.horasDisponiblesC[i].nombre,
            recargo_suma: this.horasDisponiblesC[i].recargo_suma,
            recargo_porcentaje: this.horasDisponiblesC[i].recargo_porcentaje
          });
        }
      }

      return ret;
    },
  },
  watch: {
    comuna_buscado(val) {
      this.resultado_fuse_comuna = this.fComunas.search(val);
    },
    buscando_examen(val) {
      this.resultado_fuse_examen = this.fExamen.search(val);
    },
    horasDisponibles: function () {
      var ret = [];

      for (var i = 0; i < this.horasDisponibles.length; i++) {
        const desde = this.horasDisponibles[i].desde;
        const duracion = this.horasDisponibles[i].duracion;
        const hasta = desde + duracion;

        ret.push({
          'desde': desde,
          'hasta': hasta,
          'dia': this.horasDisponibles[i].dia,
          'mes': this.horasDisponibles[i].mes,
          'año': this.horasDisponibles[i].año,
          'categorias': this.horasDisponibles[i].categorias,
          'prioridad': this.horasDisponibles[i].prioridad,
          'recargo_porcentaje': this.horasDisponibles[i].recargo_porcentaje,
          'recargo_suma': this.horasDisponibles[i].recargo_suma,
          'color': this.horasDisponibles[i].color,
          'nombre': this.horasDisponibles[i].nombre,
          'hovering': false,
          'seleccionado': false,
          'duracion': duracion
        });
      }

      this.horasDisponiblesC = ret;
    },
  },
  mounted() {
    if (this.prestador.id == 1) {
      this.get_prestadores();
      this.es_principal = true;
    }

    document.addEventListener('click', this.close);

    this.examenes_agregados = [{
      nombre: '',
      tipo_identificador: 'rut',
      nacionalidad: 'Chilena',
      sexo: '',
      fecha_nacimiento_a: 0,
      fecha_nacimiento_m: 0,
      fecha_nacimiento_d: 0,
      aseguradora_id: 1,
      apellido1: '',
      email: '',
      rut: '',
      telefono: '',
      tel_prefijo: '+56',
      seleccionando_telefono: false,
      seleccionando_rut: false,
      orden_medica: null,
      examenes: [],
      visible: true
    }];

    this.fComunas = new Fuse(this.comunas, { keys: ["Nombre"] });
    this.fExamen = new Fuse(this.examenes, { keys: ["nombre"] });

    this.hoy = new Date();
    this.hoyMes = this.hoy.getMonth();
    this.hoyDia = this.hoy.getDate();
    this.hoyAño = this.hoy.getFullYear();
    this.viendoDia = this.hoyDia;
    this.viendoMes = this.hoyMes;
    this.viendoAño = this.hoyAño;
    this.getDisponiblesMes(this.hoyMes, this.hoyAño);
  },
  beforeDestroy() {
    if (this.prestador.id != this.selectedPrestador) {
      this.reconfigure({ prestador_id: this.prestador.id });
    }

    document.removeEventListener('click', this.close);
  }
}
</script>

<style scoped>
.navigation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eaeaea;
}

.navigation-buttons button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.secondary-btn {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.secondary-btn:hover {
  background-color: #eaeaea;
}

.primary-btn {
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.primary-btn:hover {
  opacity: 0.9;
}

.primary-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Ajustes para los botones en diferentes estados */
.step-container .content-card .navigation-buttons {
  padding-top: 0;
  border-top: none;
}

.patient-form-content .navigation-buttons {
  margin-top: 1.5rem;
}

.summary-card .navigation-buttons {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}
/* Base Styles - Notion-inspired with medical touches */
.medical-order-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

/* Restriction Notice */
.restriction-notice {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fef3c7;
  color: #92400e;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 1rem;
  border: 1px solid #fbbf24;
}

/* Add Patient Section */
.add-patient-section {
  margin-top: 2rem;
  text-align: center;
}

.add-patient-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: 2px dashed #cbd5e1;
  color: #64748b;
  padding: 1rem 2rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 600;
}

.add-patient-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background-color: #f8fafc;
}

/* Calendar Layout - Mejorado estilo Google Calendar */
.calendar-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.calendar-section,
.time-section {
  display: flex;
  flex-direction: column;
}

.calendar-card,
.time-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  flex: 1;
}

.calendar-header,
.time-header {
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.calendar-title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.section-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.875rem;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.calendar-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.current-month {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.nav-buttons {
  display: flex;
  gap: 0.5rem;
}

.nav-btn {
  background: none;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background-color: #f8fafc;
}

/* Calendar Container - CORREGIDO */
.calendar-container {
  padding: 1.5rem;
}

.calendar-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  margin-bottom: 1px;
  background: #e2e8f0;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.weekday-cell {
  padding: 0.75rem 0.5rem;
  text-align: center;
  font-weight: 600;
  color: #64748b;
  font-size: 0.875rem;
  background: #f8fafc;
}

/* Calendar Weeks - NUEVA ESTRUCTURA CORREGIDA */
.calendar-weeks {
  background: #e2e8f0;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

.calendar-week {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
}

.calendar-day {
  aspect-ratio: 1;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  position: relative;
}

.calendar-day:hover:not(.empty-day):not(.unavailable-day):not(.other-month) {
  background-color: #f1f5f9;
}

.calendar-day.current-day {
  background-color: #dbeafe !important;
  color: #1d4ed8;
  font-weight: 600;
}

.calendar-day.selected-day {
  color: white !important;
  font-weight: 600;
}

.calendar-day.available-day {
  color: #059669;
  cursor: pointer;
}

.calendar-day.unavailable-day {
  color: #9ca3af;
  cursor: not-allowed;
  background-color: #f9fafb;
}

.calendar-day.other-month {
  color: #cbd5e1;
  background-color: #f9fafb;
  cursor: default;
}

.calendar-day.empty-day {
  background-color: #f9fafb;
  cursor: default;
}

.calendar-day span {
  position: relative;
  z-index: 1;
}

/* Time Section */
.time-content {
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.selected-date-info {
  margin-bottom: 1.5rem;
}

.date-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #f0f9ff;
  color: #0c4a6e;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid #bae6fd;
}

.time-slots-container {
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
}

.time-period {
  margin-bottom: 2rem;
}

.period-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.time-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.75rem;
}

.time-slot {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  position: relative;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.time-slot:hover {
  border-color: #3b82f6;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
}

.time-slot.selected {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.time-range {
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.time-surcharge {
  font-size: 0.75rem;
  color: #f59e0b;
  font-weight: 500;
}

.no-times-available {
  text-align: center;
  padding: 3rem 2rem;
  color: #64748b;
}

.no-times-icon {
  margin: 0 auto 1rem;
  color: #cbd5e1;
}

.no-times-available h4 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.5rem;
}

.no-times-available p {
  margin: 0;
  font-size: 0.875rem;
}

.loading-times {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 3rem;
  color: #64748b;
}

/* Continue Section */
.continue-section {
  text-align: center;
  margin-top: 2rem;
}

/* Step Container */
.step-container {
  margin: 1.5rem;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Step Header */
.step-header {
  margin-bottom: 2rem;
  text-align: center;
}

.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  color: white;
  border-radius: 50%;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.step-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.025em;
}

.step-subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

/* Content Cards */
.content-card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.content-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06);
}

/* Section Styles */
.patient-preview-section,
.location-section {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: 12px;
  border-left: 4px solid #3b82f6;
}

.section-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.section-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.5rem;
}

.section-description {
  color: #64748b;
  margin: 0;
}

/* Form Elements */
.medical-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.medical-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.medical-input.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.medical-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.2s ease;
}

.medical-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.medical-select.compact {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
}

/* Search and Dropdown */
.search-container {
  position: relative;
}

.search-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 2px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dropdown-item:hover {
  background-color: #f1f5f9;
}

.dropdown-item.no-results {
  color: #64748b;
  cursor: default;
}

.dropdown-item.no-results:hover {
  background-color: transparent;
}

/* Buttons */
.primary-btn {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.primary-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

.primary-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.primary-btn.full-width {
  width: 100%;
}

.secondary-btn {
  background: white;
  color: #64748b;
  border: 2px solid #e2e8f0;
  padding: 0.875rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.secondary-btn:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

/* Two Column Layout */
.two-column-layout {
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 2rem;
  align-items: start;
}

.main-column {
  min-height: 600px;
}

.summary-column {
  position: sticky;
  top: 2rem;
}

/* Patient Cards */
.patients-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.patient-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.patient-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.patient-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.patient-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.patient-avatar {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
}

.patient-title {
  font-weight: 600;
  color: #1e293b;
}

.remove-btn {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.remove-btn:hover {
  background-color: #fef2f2;
}

/* Insurance Section */
.insurance-section {
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.field-label {
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  white-space: nowrap;
}

/* Services Table */
.services-table {
  padding: 1rem 1.5rem;
  min-height: 350px;
}

.table-header {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 2px solid #e2e8f0;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
}

.table-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid #f1f5f9;
  align-items: center;
}

.table-row.delivery-row {
  background: #f8fafc;
  margin: 0 -1.5rem;
  padding: 1rem 1.5rem;
}

.col-service {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.service-icon {
  width: 24px;
  height: 24px;
  color: #3b82f6;
  flex-shrink: 0;
}

.service-name {
  font-weight: 500;
  color: #1e293b;
}

.price-display {
  font-weight: 600;
  color: #059669;
}

.select-comuna-btn {
  background: none;
  border: 1px solid #3b82f6;
  color: #3b82f6;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
}

.select-comuna-btn:hover {
  background-color: #f8fafc;
}

.remove-service-btn {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.remove-service-btn:hover {
  background-color: #fef2f2;
}

/* Add Service Row */
.add-service-row {
  padding-top: 1rem;
}

.add-service-input {
  position: relative;
}

.service-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 2px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  z-index: 1000;
  max-height: 200px;
}

.service-option {
  padding: 0.20rem .20rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.service-option:hover {
  background-color: #f1f5f9;
}

.service-option-name {
  font-weight: 500;
  color: #1e293b;
}

.service-option-price {
  font-weight: 600;
  color: #059669;
}

/* Summary Card */
.summary-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.summary-title {
  padding: 1.25rem 1.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.summary-items {
  padding: 1.25rem 1.5rem;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
}

.summary-item-name {
  font-weight: 500;
  color: #374151;
}

.summary-item-price {
  font-weight: 600;
  color: #059669;
}

.summary-divider {
  border-bottom: 2px solid #f1f5f9;
  margin: 1rem 0;
}

/* Patient Data Container */
.patient-data-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.patient-form-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.patient-form-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.patient-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  cursor: pointer;
}

.patient-form-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.expand-icon {
  color: #64748b;
  transition: transform 0.3s ease;
}

.patient-form-content {
  padding: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-field.full-width {
  grid-column: 1 / -1;
}

.input-group {
  position: relative;
  display: flex;
  align-items: center;
}

.input-prefix {
  background: #f8fafc;
  color: #64748b;
  border: 2px solid #e2e8f0;
  border-right: none;
  padding: 0.75rem 1rem;
  border-radius: 8px 0 0 8px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  z-index: 1;
}

.input-prefix:hover {
  background-color: #f1f5f9;
}

.dropdown-menu, .custom-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 2px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
}

.flag-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
}

.date-inputs {
  display: flex;
  gap: 1rem;
}

.field-error {
  color: #ef4444;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.validation-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 0.5rem;
}

.loading-indicator {
  color: #64748b;
}

.validation-success {
  color: #16a34a;
}

.validation-error {
  color: #ef4444;
}

.remove-patient-btn {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  width: fit-content;
}

.remove-patient-btn:hover {
  background-color: #fef2f2;
}

/* Address Card */
.address-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.address-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.address-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.address-form {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.address-input-container {
  position: relative;
}

.address-display {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  font-weight: 500;
  color: #374151;
  z-index: 1;
}

.property-type-buttons {
  display: flex;
  gap: 1rem;
}

.property-type-btn {
  background: none;
  border: 2px solid #e2e8f0;
  color: #64748b;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.property-type-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background-color: #f8fafc;
}

.property-type-btn.active {
  border-color: #3b82f6;
  color: #3b82f6;
  background-color: #f8fafc;
}

/* Prescriptions Container */
.prescriptions-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.prescription-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.prescription-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.status-indicator {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-warning {
  background: #fef3c7;
  color: #92400e;
}

.status-success {
  background: #ecfdf5;
  color: #065f46;
}

.patient-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.prescription-actions {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  text-align: center;
}

.upload-btn {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

.file-input {
  display: none;
}

.not-applicable {
  color: #64748b;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
  padding: 0.75rem 1.5rem;
}

.uploaded-files {
  padding: 1rem 1.5rem;
}

.files-title {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.75rem;
}

.files-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8fafc;
  border-radius: 8px;
  padding: 0.5rem 1rem;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: #374151;
}

.remove-file-btn {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.remove-file-btn:hover {
  background-color: #fef2f2;
}

.prescription-info {
  background: #f0f9ff;
  color: #0c4a6e;
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid #bae6fd;
  font-size: 0.875rem;
}

/* Loading and Success States */
.loading-container,
.success-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content,
.success-content {
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.success-icon {
  margin-bottom: 1rem;
  color: #16a34a;
}

.success-actions {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: center;
}

/* Medical Spinner */
.medical-spinner {
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

.medical-spinner.small {
  width: 24px;
  height: 24px;
  border-width: 3px;
}

/* [Todo tu CSS existente permanece igual hasta el final] */

/* Responsive Styles - Added below your existing media queries */
@media (max-width: 1200px) {
  .two-column-layout {
    grid-template-columns: 1fr;
  }

  .summary-column {
    position: static;
  }

  .medical-order-page {
    padding-left: 200px;
  }
}

@media (max-width: 1024px) {
  .calendar-layout {
    grid-template-columns: 1fr;
  }

  .time-grid {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }
}

@media (max-width: 768px) {
  .medical-order-page {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-field.full-width {
    grid-column: auto;
  }

  .date-inputs {
    flex-direction: column;
    gap: 0.5rem;
  }

  .step-title {
    font-size: 1.5rem;
  }

  .step-subtitle {
    font-size: 1rem;
  }

  .content-card {
    padding: 1.5rem;
  }

  .patient-preview-section,
  .location-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .section-icon {
    margin-bottom: 1rem;
  }

  .table-header,
  .table-row {
    grid-template-columns: 1fr auto;
  }

  .table-row .remove-service-btn {
    grid-column: 2;
  }
}

@media (max-width: 576px) {
  .medical-order-page {
    padding: 1rem;
  }

  .step-container {
    margin-bottom: 2rem;
  }

  .step-number {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }

  .calendar-weekdays,
  .calendar-week {
    grid-template-columns: repeat(7, minmax(30px, 1fr));
  }

  .weekday-cell {
    padding: 0.5rem 0.25rem;
    font-size: 0.75rem;
  }

  .calendar-day {
    min-height: 36px;
    font-size: 0.875rem;
  }

  .time-grid {
    grid-template-columns: 1fr 1fr;
  }

  .time-slot {
    min-height: 50px;
    padding: 0.5rem;
  }

  .primary-btn,
  .secondary-btn {
    padding: 0.75rem 1.5rem;
    font-size: 0.875rem;
  }

  .patient-header,
  .insurance-section,
  .services-table {
    padding: 0.75rem 1rem;
  }

  .patient-form-header,
  .patient-form-content,
  .address-form {
    padding: 1rem;
  }

  .property-type-buttons {
    flex-direction: column;
  }
}

@media (max-width: 400px) {
  .time-grid {
    grid-template-columns: 1fr;
  }

  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .table-row .remove-service-btn {
    grid-column: 1;
    justify-self: start;
  }

  .col-service {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 1200px) {
  .medical-order-page {
    padding-left: 0px;
  }
}
</style>